import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import  Swal  from 'sweetalert2';
import { UsuariosService } from './../service/usuarios.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-senha-primeiro-acesso',
  templateUrl: './senha-primeiro-acesso.component.html',
  styleUrls: ['./senha-primeiro-acesso.component.css']
})
export class SenhaPrimeiroAcessoComponent implements OnInit {
  disable = false
  form: FormGroup
  password = true
  text = false

  constructor(
    public dialogRef: MatDialogRef<SenhaPrimeiroAcessoComponent>,
    private formbuilder: FormBuilder,
    private usuarioService: UsuariosService,
    private route: Router
  ) { 
    this.form = this.formbuilder.group({
      vc_senha: [null,  [Validators.required, Validators.minLength(6)]]
    })
  }

  ngOnInit(): void {
  }

  changeInput(input: any): any {
    input.type = input.type === 'password' ? 'text' : 'password';
    if(input.type == 'text'){
      this.password = false
      this.text = true
    } else if(input.type =='password') {
      this.text = false
      this.password = true
    }
  }

  atualizar(){
    this.usuarioService.atualizarSenha(this.form.value, localStorage.getItem('usuarioId')).subscribe((senha: any) => {
      
      this.dialogRef.close();
      Swal.fire({
        icon: 'success',
        title: 'Senha alterada com sucesso',
      })
    }, erro => {
      this.route.navigate(['home'])
    })
  }

}
